import { useContext } from "react"
import BaseModal from "../layout/BaseModal"
import BaseHeadline from "./BaseHeadline"
import { ThemeContext } from "../../context/ThemeContext"
import { ContactModalType } from "../../types"
import { API } from "../../constants/constants"
import MailButton from "./MailButton"
import BaseSubheadline from "./BaseSubheadline"
import BaseRichtext from "./BaseRichtext"
import { ReactComponent as CONTACT } from "../../assets/contact.svg"

export default function ContactModal(props: ContactModalType) {
    const themeColors = useContext(ThemeContext)

    const chunkArray = <T,>(arr: T[], size: number): T[][] => {
        return arr.reduce((acc: T[][], _, i) => {
            if (i % size === 0) acc.push(arr.slice(i, i + size))
            return acc
        }, [])
    }

    const pairedItems = chunkArray(props.contacts, 2)
    
    return (
        <BaseModal contact modalId={1}>
            <BaseHeadline
                headlineType={4}
                classProps="mt-8 md:mt-0 break-words"
                label={"Ansprechpartner:innen"}
                customColor={themeColors?.color?.bg2 === themeColors?.color?.text ? "#bg-neutral" : themeColors?.color?.text}
            />
            {pairedItems.map((pair, index) => (
                <div key={index} className="flex flex-col lg:flex-row justify-between items-center pt-8 lg:pb-16 pr-4 lg:pr-0 gap-8 lg:gap-0">
                    {pair.map((contact, contactIndex) => {

                        const positionLength = contact.pageSettingContact?.position?.length ?? 0;
                        const fullNameLength = contact.pageSettingContact?.fullName?.length ?? 0;

                        const showIcon =
                            contactIndex % 2 !== 0 ||
                            !(positionLength > 52 || fullNameLength > 21);

                        const numbers = contact.pageSettingContact?.mainPhone?.split(',').map(num => num.trim()).filter(num => num !== '');

                        const landline = numbers[0];
                        const mobile = numbers[1];

                        return (
                            <div
                                key={contactIndex}
                                className={`flex w-full lg:max-w-[65%]  ${contactIndex % 2 === 0 ? "lg:items-start lg:-mr-40" : "lg:items-end lg:flex-row-reverse lg:-ml-40"
                                    }`}>
                                <div className="relative z-[51]">
                                    <img
                                        src={API + contact.pageSettingContact?.avatar?.url}
                                        alt={contact.pageSettingContact?.avatar?.description ?? contact.pageSettingContact?.avatar?.name}
                                        className="hidden sm:block h-full w-44 lg:aspect-auto lg:h-[35rem] lg:w-[23rem] xl:w-[25rem] object-cover border-4 border-base-300 rounded-default "
                                    />
                                    <div className="hidden lg:flex absolute top-full -translate-y-1/2 w-full justify-center ">
                                        <MailButton mail={contact.pageSettingContact?.mainEmail} />
                                    </div>
                                </div>
                                <div
                                    className={`flex flex-col gap-4 text-base bg-base-300 rounded-default w-full lg:w-96 text-neutral relative px-8 ${contactIndex % 2 === 0 ? "py-4 lg:pr-6 lg:pl-20 lg:-ml-6" : "py-4 lg:pl-6 lg:pr-20 lg:-mr-6"
                                        }`}>
                                    <img
                                        src={API + contact.pageSettingContact.avatar?.url}
                                        alt={contact.pageSettingContact?.avatar?.description ?? contact.pageSettingContact?.avatar?.name}
                                        className="sm:hidden w-32 h-32 object-cover border-4 border-base-300 rounded-full "
                                    />
                                    <div>
                                        <BaseSubheadline label={contact.pageSettingContact?.position + ":"} />
                                        <p className="text-base pb-4">{contact.pageSettingContact?.fullName}</p>
                                        
                                        {landline && <BaseRichtext content={"Tel: " + landline } />}
                                        {mobile && <BaseRichtext content={"Mobil: " + mobile} />}
                                        {contact.pageSettingContact?.mainFax && (
                                            <BaseRichtext content={"Fax: " + contact.pageSettingContact?.mainFax} />
                                        )}
                                        {contact.pageSettingContact?.mainEmail && (
                                            <BaseRichtext content={"E-Mail: " + contact.pageSettingContact?.mainEmail} />
                                        )}
                                        <CONTACT
                                            className={`${showIcon ? '' : 'sm:hidden'} hidden sm:block w-20 object-contain fill-primary absolute top-1/2 -translate-y-1/2 right-10`}
                                        />
                                    </div>
                                    <div className="w-full sm:hidden">
                                        <MailButton
                                            mail={contact.pageSettingContact?.mainEmail}
                                            classParent="w-full"
                                            classProps="w-full justify-center px-4"
                                        />
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            ))}
        </BaseModal>
    )
}
